export default __webpack_public_path__ + "img/rule436back-469ddc3d.png";